module.exports = __webpack_public_path__ + "static/media/onboarding_video.0cfcd23.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding_video.mp4
// module id = 2234
// module chunks = 1